<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <loader v-if="loading" />
    <b-col class="white-container" v-else>
      <h5 class="mb-4">
        Export Info
      </h5>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Title
          </label>
        </b-col>
        <b-col>
          <FormFieldInput 
            v-model="exportObject.title"
            :read-only="true"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Export Type
          </label>
        </b-col>
        <b-col>
          <FormFieldInput 
            v-model="exportObject.key"
            :read-only="true"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Status
          </label>
        </b-col>
        <b-col>
          <b-badge
            v-if="exportObject.status"
            :variant="exportObject.status == 'success' ? 'success' : 'danger'"
            class="font-weight-light"
            style="font-size: 12px"
          >
            {{ exportObject.status }}
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Created at
          </label>
        </b-col>
        <b-col>
          <FormFieldInput 
            value=""
            :placeholder="formatDate(exportObject.created_at, 'L')"
            :read-only="true"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Generated at
          </label>
        </b-col>
        <b-col>
          <FormFieldInput 
            value=""
            :placeholder="formatDate(exportObject.generated_at, 'L')"
            :read-only="true"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Export Fields
          </label>
        </b-col>
        <b-col>
          <treeselect
            :options="[]"
            :value="exportObject.fields"
            :multiple="true"
            :disabled="true"
            :value-consists-of="'LEAF_PRIORITY'"
            :value-format="'object'"
            :close-on-select="false"
            :normalizer="normalizer"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Export Filters
          </label>
        </b-col>
        <b-col>
          <div v-for="(filter, key) in exportObject.filters" :key="key">
            {{ usersFilters.filter((el) => el.name == key)[0].label }}: {{ filter }}
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="3">
          <label class="pr-0">
            Total Rows
          </label>
        </b-col>
        <b-col>
          <FormFieldInput 
            v-model="exportObject.total_rows"
            :read-only="true"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col>
          <b-button
            v-if="exportObject.status == 'success'"
            @click="download(exportObject)"
            variant="outline-primary"
            class="mr-3"
          >
            {{ $t('export.download') }} <i class="fa fa-download ml-1" />
          </b-button>
          <b-button
            v-if="exportObject.status == 'success'"
            @click="reiterate"
            variant="outline-primary"
          >
            {{ $t('export.reiterate') }} <i class="fa fa-copy ml-1" />
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import axios from '@/utils/axios';
import Cookies from 'js-cookie';
import usersFilters from '@/views/users/usersFilters.js';
import FormFieldInput from '@/components/forms/fields/formFieldInput';

export default {
  name: 'ExportView',
  components: {FormFieldInput},
  props: {},
  data() {
    return {
      loading: true,
      exportObject: {},
      usersFilters: usersFilters,
    };
  },
  created() {
    this.getExportObject();
  },
  methods: {
    normalizer(node) {
      return {
        id: node.key,
        label: node.title,
        children: node.children,
      };
    },
    download(exportRequest) {
      const token = Cookies.get('token');

      axios({
        url: exportRequest.download_link,
        method: 'GET',
        responseType: 'blob',
        headers: {
          token,
        },
      }).then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${exportRequest.id}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    reiterate() {
      this.postData(
        `export-requests/${this.$route.params.id}/reiterate`,
        { recipient_email: null },
        false,
      ).then(() => {
        // redirect
        this.$router.push({ path: `/${this.exportObject.key}` });
      });
    },
    getExportObject() {
      this.getData(`export-requests/${this.$route.params.id}`, null, false).then(({ data }) => {
        this.exportObject = data.item;
        this.loading = false;
      });
    },
  },
};
</script>
